<template>
  <div>
    <div v-if="approvalsToShow.length" class="approvals">
      <span
        :style="`color: ${color}`"
        v-for="(approval, index) in approvalsToShow"
        :key="`appr-${type}-${index}`"
      >
        <i :class="`fa-duotone fa-solid ${icon}`"></i>{{ approval.abbr }}
      </span>

      <span
        v-if="hideAdditionalBoardApprovals && moreBoardApprovalsCount > 0"
        :key="'more-boards'"
      >
        And <strong>{{ moreBoardApprovalsCount }}</strong> Board Approvals
      </span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    approvals: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: '#0eb285'
    },
    icon: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    hideAdditionalBoardApprovals: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    approvalsToShow() {
      // If not the "hideAdditionalBoardApprovals" value, keep existing behavior
      if (!this.hideAdditionalBoardApprovals) {
        return this.approvals || [];
      }

      const all = Array.isArray(this.approvals) ? this.approvals : [];
      const nationals = all.filter(a => a?.is_national_approval === true);
      const nonNationals = all.filter(a => !a?.is_national_approval);

      // Always display all nationals first
      const displayed = [...nationals];

      if (nationals.length > 5) {
        // Case A: No non-national approvals shown
        return displayed;
      }

      // Case B: Fill up to 5 with non-national approvals
      const room = 5 - nationals.length;
      const addNonNationals = nonNationals.slice(0, room);

      return [...displayed, ...addNonNationals];
    },

    moreBoardApprovalsCount() {
      if (this.type !== 'approved') return 0;

      const all = Array.isArray(this.approvals) ? this.approvals : [];
      const nationals = all.filter(a => a?.is_national_approval === true);
      const nonNationals = all.filter(a => !a?.is_national_approval);

      if (nationals.length > 5) {
        // Case A: show count of all non-national approvals
        return nonNationals.length;
      }

      // Case B: show how many non-national approvals are left undisplayed
      const leftApprovals = 5 - nationals.length;
      const shownNonNationals = Math.max(0, Math.min(leftApprovals, nonNationals.length));
      return Math.max(0, nonNationals.length - shownNonNationals);
    }
  }
}
</script>

<style scoped lang="scss">
.approvals {
  margin-bottom: var(--attendee-gap-sm);
  font-size: 16px;

  span {
    display: inline-block;
    white-space: nowrap;
    font-size: 16px;
    margin-right: 1em;
  }

  svg {
    margin-right: 5px;

    @media (max-width: 900px) {
      display: none;
    }
  }
}
</style>
